import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';

export default class DetailViewContextAppliedMessage extends Message {

    public constructor(params: any) {
        super(params);
    }
}

ComponentManager.setMessage('DetailViewContextAppliedMessage', DetailViewContextAppliedMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');